import _ from 'lodash';
import $ from 'jquery';
import {_alertServerErrorParsed} from 'module/ConfirmDialog/component/ConfirmDialogContainer';

/* All jquery error handler methods moved from NotificationModule */

type ModifiedJQXHR = JQueryXHR & { _SISparseServerErrorDone?: boolean }
type Settings = { skipGlobalSISErrorHandler?: boolean }
type Options = { preMessage?: string } | undefined

/** @deprecated use ConfirmDialogContainer.tsx */
function remoteErrorHandler(_options: Options, jqXHR: ModifiedJQXHR, statusOrSettings: Settings, thrownError: any) {
	if (jqXHR && jqXHR._SISparseServerErrorDone || thrownError === "abort") {
		return $.Deferred().resolve(true);
	}
	//prevent multiple firing for same error
	if (jqXHR) jqXHR._SISparseServerErrorDone = true;
	let errorJSON;
	try {
		errorJSON = jqXHR.responseJSON || JSON.parse(jqXHR.responseText);
	} catch (err) {
		console.error("Could not parse errorJSON.", err, window.event, jqXHR, statusOrSettings, thrownError);
		return _alertServerErrorParsed();
	}
	let errorMsg = $.trim(errorJSON.message);
	if (!errorMsg) {
		console.warn('Invalid server error.', errorJSON);
	}
	if (_options && _options.preMessage) errorMsg = _options.preMessage + "\n" + errorMsg;
	return _alertServerErrorParsed(errorMsg);
}

/**
 * @deprecated use ConfirmDialogContainer.tsx
 * can be used with .fail(NotificationModule.parseServerError). params are correctly filled by jquery
 * @param jqXHR
 * @param statusOrSettings dependent of usage this is either its state (.fail) or the ajax settings (.ajaxError) -> do not use
 * @param thrownError
 */
export function serverErrorHandlerJQ(jqXHR: ModifiedJQXHR, statusOrSettings: Settings, thrownError: any) {
	return remoteErrorHandler(undefined, jqXHR, statusOrSettings, thrownError);
}

/**
 * @deprecated use ConfirmDialogContainer.tsx
 *
 * can be used with $(document).ajaxError(NotificationModule.globalAjaxErrorHandler)
 * @param jqEvent
 * @param jqXHR
 * @param {boolean} [jqXHR.skipGlobalSISErrorHandler]
 * @param settings
 * @param thrownError
 */
export function globalAjaxErrorHandler(jqEvent: JQueryEventObject, jqXHR: ModifiedJQXHR, settings: Settings, thrownError: any) {
	if (settings && settings.skipGlobalSISErrorHandler) return; //prevent multiple firing for same error
	serverErrorHandlerJQ(jqXHR, settings, thrownError);
}

/** @deprecated use ConfirmDialogContainer.tsx */
export function generateErrorHandler(options: Options | string) {
	if (typeof options === 'string') options = {preMessage: options};
	return _.partial(remoteErrorHandler, options || {});
}